/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PhoneCallIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACAElEQVR4nN1VPWsUURQdRWwUFMROo40Y/AC7pNsqIGbux2x4e8+uipBOQqzUdlsLETH2gjZ+FIKIjSSBaP6An5WdCKIohqBLElx5u5s4zLyZLGEL8cIt3nL2nHvPfe9OFP13weyOseIuiX0ite8ijZNZDCkWWW2Z1d6Q4OZ4UjvRF3ks9QkW+8WKdirv5IoQe5HGkGCNxG4753aWV54nb5Pgp+r5fVn82Ni5XcwYYbVbrGh18GKzhSLeliz5esZil8s6F2mcYsXHrghmgiDveZEAi31oNpvbN7CKRVIssdpjZnc0JdLq2EU4HhDAWqGAoh1X68PhGdg3ETvY/R0zHVvVbgQssi8hYhJbYbXrURRtS+OT5OwBFjzr2fKwU2RSG+2dX+c7UHuVI1c8L7uCvvJeFz/82Tm3u/e/pdAMnmYFzlQbh4rI03aRYqHo/BeY4FK+A7sYDSp8tQGL3lYqlR0DEyHFfH7QdmVwAt1b8DsjssoMDuFZcY3UHrFi8rRz+/sSYbEHgeu6SoKrabtirVey+4gFL33HceyGCgVELuxlsffhN4F3nGBKxA6H7dx4O59Luxiv1o+Q2Neyl12Wfu1sapUXKepk0xS719c8nHN7SHE/MPiybAWXXVkwY4QUc32RK2rRViOO3RAJpkntid9dfpjrnntb/Edry+T/bPwByzu8YrO7nwoAAAAASUVORK5CYII=)
 */
export const PhoneCallIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 7.4A5.4 5.4 0 0 1 7.4 2c.36 0 .7.22.83.55l1.93 4.64a1 1 0 0 1-.43 1.25L7 10a8.52 8.52 0 0 0 7 7l1.12-2.24a1 1 0 0 1 1.19-.51l5.06 1.56c.38.11.63.46.63.85C22 19.6 19.6 22 16.66 22h-.37C8.39 22 2 15.6 2 7.71V7.4ZM13 3a1 1 0 0 1 1-1 8 8 0 0 1 8 8 1 1 0 1 1-2 0 6 6 0 0 0-6-6 1 1 0 0 1-1-1Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13 7a1 1 0 0 1 1-1 4 4 0 0 1 4 4 1 1 0 1 1-2 0 2 2 0 0 0-2-2 1 1 0 0 1-1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
